// src/components/layout/DiscordInviteBar.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import {
    DISCORD_INVITE_URL,
    dismissDiscordBar,
    shouldShowDiscordBar
} from '../../utils/promoChrome';
import './DiscordInviteBar.css';

function DiscordInviteBar() {
    const [visible, setVisible] = useState(() => shouldShowDiscordBar());

    if (!visible) return null;

    const handleDismiss = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dismissDiscordBar();
        setVisible(false);
    };

    return (
        <div className="discord-invite-bar">
            <a
                className="discord-invite-link"
                href={DISCORD_INVITE_URL}
                target="_blank"
                rel="noopener noreferrer"
                title="Join Discord"
            >
                <span className="discord-invite-icon" aria-hidden="true">
                    <FontAwesomeIcon icon={faDiscord} />
                </span>
                <span className="discord-invite-copy">Join Discord</span>
            </a>
            <button
                type="button"
                className="discord-invite-close"
                onClick={handleDismiss}
                aria-label="Hide Discord invite"
            >
                ×
            </button>
        </div>
    );
}

export default DiscordInviteBar;
